import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess6020Status: 'idle',
    startProcess6020Error: undefined as any,
    loadUserParamsProcess6020Status: 'idle',
    loadUserParamsProcess6020Error: undefined as any,

    process6020List: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess6020 = createAsyncThunk('process6020Slice/startProcess6020', async ({ process6020 }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess6020/`,
        prepareData(process6020),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess6020Status } = getState().process6020Slice
        return startProcess6020Status !== 'pending'
    }
})

export const loadUserParamsProcess6020 = createAsyncThunk('process6020Slice/loadUserParamsProcess6020', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess6020/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess6020Status } = getState().process6020Slice
        return loadUserParamsProcess6020Status !== 'pending'
    }
})

const Process6020Slice = createSlice({
    name: 'process6020Slice',
    initialState,
    reducers: {
        resetstartProcess6020: (state) => {
            state.job = undefined
            state.startProcess6020Error = undefined
        },
        resetstartProcess6020Error: (state) => {
            state.startProcess6020Error = undefined
        },
        resetloadUserParamsProcess6020: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess6020Error = undefined
        },
        resetloadUserParamsProcess6020Error: (state) => {
            state.loadUserParamsProcess6020Error = undefined
        },
        removeFromProcess6020ListById: (state, action) => {
            state.process6020List = state.process6020List.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess6020ListByIds: (state, action) => {
            state.process6020List = state.process6020List.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process6020List = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess6020Status = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process6020List = []
            state.startProcess6020Status = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess6020.pending, (state) => {
            state.startProcess6020Status = 'pending'
            state.startProcess6020Error = undefined
        })
        builder.addCase(startProcess6020.fulfilled, (state, action) => {
            state.startProcess6020Status = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess6020.rejected, (state, action) => {
            state.startProcess6020Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess6020Error = action.error.message
            } else {
                state.startProcess6020Error = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess6020.pending, (state) => {
            state.loadUserParamsProcess6020Status = 'pending'
            state.loadUserParamsProcess6020Error = undefined
        })
        builder.addCase(loadUserParamsProcess6020.fulfilled, (state, action) => {
            state.loadUserParamsProcess6020Status = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess6020.rejected, (state, action) => {
            state.loadUserParamsProcess6020Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess6020Error = action.error.message
            } else {
                state.loadUserParamsProcess6020Error = action.payload
            }
        })

    }
})

export const {
    resetstartProcess6020,
    resetstartProcess6020Error,
    resetloadUserParamsProcess6020,
    resetloadUserParamsProcess6020Error,
    removeFromProcess6020ListById,
    removeFromProcess6020ListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process6020Slice.actions
export default Process6020Slice.reducer
